import { useEffect, useState } from "react";

export default function useSpeechTimer() {
  const [seconds, setSeconds] = useState(240);
  const [isRunning, setIsRunning] = useState(false);
  const [activePreset, setActivePreset] = useState("Constructive");

  useEffect(() => {
    if (!isRunning) return undefined;
    const timer = window.setInterval(() => {
      setSeconds((current) => Math.max(0, current - 1));
    }, 1000);
    return () => window.clearInterval(timer);
  }, [isRunning]);

  useEffect(() => {
    if (seconds === 0) setIsRunning(false);
  }, [seconds]);

  const resetTimer = () => {
    setActivePreset("Constructive");
    setSeconds(240);
    setIsRunning(false);
  };

  const selectPreset = (label, value) => {
    setActivePreset(label);
    setSeconds(value);
    setIsRunning(false);
  };

  return {
    activePreset,
    isRunning,
    resetTimer,
    seconds,
    selectPreset,
    setIsRunning,
  };
}
